export default __webpack_public_path__ + "static/media/slide16.fdba0c26.webp";